<template>
  <div>
    <basic-container>
      <!-- 搜索栏 -->
      <PartnerIncomeLogSearch 
        ref="searchForm" 
        @search="handleSearch" 
        @export="handleExport"
        :searchForm="searchForm"
        :loading="loading"
      />
      
      <!-- 收益记录列表 -->
      <div class="income-log-table-container">
        <PartnerIncomeLogTable 
          ref="incomeLogTable" 
          :tableData="tableData" 
          :loading="loading"
          :current="page.current"
          :size="page.size"
        />
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <ElementPagination
          :current-page="page.current"
          :page-size="page.size"
          :page-sizes="[50, 100, 200, 500]"
          :total="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </basic-container>
  </div>
</template>

<script>
import PartnerIncomeLogSearch from "./components/search.vue";
import PartnerIncomeLogTable from "./components/table.vue";
import ElementPagination from '@/components/ElementPagination';
import { getPartnerIncomeLogList, exportPartnerIncomeLog } from "@/api/markManage/partnerIncomeLog";
import moment from 'moment';

export default {
  name: "PartnerIncomeLog",
  components: {
    PartnerIncomeLogSearch,
    PartnerIncomeLogTable,
    ElementPagination
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: {
        current: 1,
        size: 50,
        total: 0
      },
      // 搜索表单
      searchForm: {
        startTime: '', // 支付开始时间
        endTime: '', // 支付结束时间
        keyword: '', // 合伙人/下单账号/订单号/结算单号
        settlementStatus: '', // 结算状态：0-待结算,1-结算中,2-已结算
        orderType: '' // 订单类型：1-支付成功,2-退款
      }
    };
  },
  created() {
    const endDate = moment().format('YYYY-MM-DD');
    const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
    this.searchForm.startTime = startDate;
    this.searchForm.endTime = endDate;
    this.getPartnerIncomeLogList();
  },
  methods: {
    async getPartnerIncomeLogList() {
      const requestParams = {
        current: this.page.current,
        size: this.page.size
      };
      
      if (this.searchForm.startTime) {
        requestParams.startTime = this.searchForm.startTime;
      }
      if (this.searchForm.endTime) {
        requestParams.endTime = this.searchForm.endTime;
      }
      
      if (this.searchForm.keyword) {
        requestParams.keyword = this.searchForm.keyword;
      }
      if (this.searchForm.settlementStatus !== '' && this.searchForm.settlementStatus !== undefined && this.searchForm.settlementStatus !== null) {
        requestParams.settlementStatus = this.searchForm.settlementStatus;
      }
      if (this.searchForm.orderType !== '' && this.searchForm.orderType !== undefined && this.searchForm.orderType !== null) {
        requestParams.orderType = this.searchForm.orderType;
      }
      
      this.loading = true;
      try {
        const { data } = await getPartnerIncomeLogList(requestParams);

        if(data.code === 200) {
          const list = data.data.records || data.data || [];
          
          this.page.total = data.data.total || 0;
          if (this.page.total > 0 && list.length === 0 && this.page.current > 1) {
            this.page.current = this.page.current - 1;
            this.getPartnerIncomeLogList();
            return;
          }

          this.tableData = list.map((item, index) => {
            return {
              id: item.id,
              // 生成唯一 key：id + index + orderNum，避免重复 id 导致的渲染问题
              uniqueKey: `${item.id}_${index}_${item.orderNum || ''}_${item.orderType || ''}`,
              partnerName: item.partnerName || '',
              orderNum: item.orderNum || '',
              orderType: item.orderType || '',
              userPhone: item.userPhone || '',
              amount: item.amount || 0,
              revenueAmount: item.revenueAmount || 0,
              refundAmount: item.refundAmount || 0,
              settlementNo: item.settlementNo || '',
              settlementStatus: item.settlementStatus !== undefined ? item.settlementStatus : '',
              payTime: item.payTime || '',
              refundTime: item.refundTime || '',
              goodsName: item.goodsName || '',
              ...item
            };
          });
        } else {
          this.$message.error(data.msg || '获取列表失败');
        }
      } catch (error) {
        this.$message.error('获取列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    handleSearch(params) {
      this.page.current = 1;
      this.searchForm = params;
      this.getPartnerIncomeLogList();
    },

    async handleExport(params) {
      try {
        this.$message.info('正在导出，请稍候...');
        const response = await exportPartnerIncomeLog(params);
        
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `合伙人收益记录_${moment().format('YYYY-MM-DD')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        
        this.$message.success('导出成功');
      } catch (error) {
        this.$message.error('导出失败');
      }
    },

    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getPartnerIncomeLogList();
    },

    handleCurrentChange(val) {
      this.page.current = val;
      this.getPartnerIncomeLogList();
    }
  }
};
</script>

<style lang="scss" scoped>
.income-log-table-container {
  margin: 20px 0;
}

.pagination-container {
  margin-top: 20px;
}
</style>

